import { Routes } from '@angular/router';

export const errorPagesRoutes: Routes = [
	{
		path: 'error',
		children: [
			{
				path: '403',
				loadComponent: () => import('./forbidden/forbidden-page.component').then(c => c.ForbiddenPageComponent),
				data: { title: 'Access Forbidden' }
			},
			{
				path: '404',
				loadComponent: () => import('./not-found/not-found-page.component').then(c => c.NotFoundPageComponent),
				data: { title: 'Page not found' }
			}
		]
	},
	{ path: '**', redirectTo: 'error/404' }
];
